import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    route: [], // 路由信息
    projectListVisible: false // 项目列表
  },
  mutations: {
    setRoute (state, data) {
      state.route = data
    },
    setProjectVisible (state, data) {
      state.projectListVisible = data
    }
  },
  actions: {
    changeRoute ({ commit }, data) {
      commit('setRoute', data)
    },
    changeProjectVisible ({ commit }, data) {
      commit('setProjectVisible', data)
    }
  },
  modules: {
  }
})
